export class MathUtils {
  static round(nbr: number, precision: number = 2): number {
    return +(Math.round(Number(`${nbr.toFixed(13)}e+${precision}`))  + `e-${precision}`);
  }

  static roundHalfEven(nbr: number, precision: number = 2): number {
    const shifted = Number(`${nbr.toFixed(13)}e+${precision}`);
    const floor = Math.floor(shifted);
    const rounded = shifted - floor === 0.5 ? (floor % 2 === 0 ? floor : floor + 1) : Math.round(shifted);
    return +(rounded + `e-${precision}`);
  }
}
